<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <div class="rfi-filters flex flex-row gap-[20px] flex-1 mt-[7px]" data-testid="forms-filters">
      <app-project-details-page-date-filter [defaultDateValue]="defaultDateValue" />
      <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
        <form [formGroup]="form" class="flex-1 min-w-0">
          <div class="search w-full">
            <mat-icon (click)="search()" svgIcon="search"></mat-icon>
            <input
              class="search-input"
              data-testid="forms-search"
              formControlName="searchText"
              matInput
              placeholder="Search"
              />
            @if (form?.controls?.searchText?.value) {
              <mat-icon (click)="close()" svgIcon="close"></mat-icon>
            }
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="list-section">
    <div class="rfi-list-table flex flex-col gap-[40px]">
      @if (rows?.length) {
        <div class="bit-items-table">
          <table [dataSource]="rows" class="mat-elevation-z8 table" mat-table>
            <ng-container matColumnDef="formNo">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Form No.</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-8">{{ row?.form_number || '—' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Date</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.report_date | date : 'MMM d, y' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="inspector">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Inspector</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.inspector || '—' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="bidItems">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Bid items</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.bid_item_count || 0 }}</div>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              data-testid="forms-row"
              [attr.data-form-id]="row.id"
              (click)="openRow(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              mat-row
            ></tr>
          </table>
        </div>
      }

      @if (!loading && !rows?.length) {
        <div class="no-data text-type-8 mt-[80px]" data-testid="forms-empty">No data available.</div>
      }

      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination?.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator"
        />
    </div>
  </div>
</div>
